import React from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import {
  actions as searchMapActions,
  selectors as searchMapSelectors,
} from '@rover/react-lib/src/pages/search/SearchPage/SearchMap.duck';
import {
  effects as searchPageEffects,
  selectors as searchPageSelectors,
} from '@rover/react-lib/src/pages/search/SearchPage/SearchPage.duck';
import { SearchUIContextProvider } from '@rover/shared/js/providers/SearchUIContextProvider';

import {
  effects as searchFiltersEffects,
  selectors as searchFiltersSelectors,
} from './SearchFilters.duck';
import SearchPage from './SearchPage';

const effects = {
  updateFiltersAndFireSearchOnChange: searchPageEffects.updateFiltersAndFireSearchOnChange,
  fireSearchFiltersClickEvent: searchPageEffects.fireSearchFiltersClickEvent,
  updateMobileFilters: searchFiltersEffects.updateFilters,
  fireSearch: searchPageEffects.fireSearch,
};

const actions = {
  setShowDynamicMap: searchMapActions.setShowDynamicMap,
};

const selector = (state) => ({
  advancedFiltersCount: searchFiltersSelectors.getAdvancedFiltersCount(state),
  isDateConstrained: searchFiltersSelectors.getIsDateConstrained(state),
  isModalDisabled: searchPageSelectors.getIsModalDisabled(state),
  inVariantSimplifiedMobileOwnerSearchFormExperiment:
    searchPageSelectors.getIsInSimplifiedMobileOwnerSearchFormExperiment(state),
  isRollout1SimplifiedMobileOwnerSearchFormExperiment:
    searchPageSelectors.getRollout1SimplifiedMobileOwnerSearchForm(state),
  isRollout2SimplifiedMobileOwnerSearchFormExperiment:
    searchPageSelectors.getRollout2SimplifiedMobileOwnerSearchForm(state),
  isRollout3SimplifiedMobileOwnerSearchFormExperiment:
    searchPageSelectors.getRollout3SimplifiedMobileOwnerSearchForm(state),
  hasPets: searchFiltersSelectors.getHasPetCounts(state),
  showDynamicMap: searchMapSelectors.getShowDynamicMap(state),
});

const SearchPageContainer = (): JSX.Element => {
  return (
    <SearchUIContextProvider>
      <Connect
        actions={actions}
        effects={effects}
        selector={selector}
        onMount={[searchPageEffects.fireSearchSearchPageVisitEvent]}
      >
        {(connectedProps) => <SearchPage {...connectedProps} />}
      </Connect>
    </SearchUIContextProvider>
  );
};

SearchPageContainer.prefetchData = () => searchPageEffects.prefetchDataAndInitialize;

export default SearchPageContainer;
